import React from "react";
// nodejs library that concatenates classes
import clsx from "clsx";
// JavaScript library that creates a callendar with events
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Helmet from "react-helmet";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FilledInput from "@material-ui/core/FilledInput";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import FeatureInfoWithBox from "components/Custom/FeatureInfoWithBox";
// @material-ui/lab components
// @material-ui/icons components
import Check from "@material-ui/icons/Check";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import AlternativeHeader from "components/Headers/AlternativeHeader.js";
import listPlugin from '@fullcalendar/list';

// core components
import componentStyles from "assets/theme/views/admin/calendar.js";
import componentStylesButtons from "assets/theme/components/button.js";
import { useEtoroUser } from "contexts/EtoroUserContext";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

const FullCalendarWrapper = styled.div`
  .fc-content {
    cursor: pointer;
  };
  .fc-event-main {
    cursor: pointer;
    overflow: hidden;
  };
  .fc.fc-theme-standard td, .fc.fc-theme-standard th, .fc.fc-theme-standard .fc-scrollgrid {
    border-color: ${props => props.theme.palette.bsColors.ChartLines} !important;
  };
  .fc-list-day-cushion {
    background-color: ${props => props.theme.palette.bsColors.MainBlue};
  };
  .fc-list-day-text {
    color: ${props => props.theme.palette.white.main};
  };
  .fc-list-event-time {
    display: none;
  };
  .fc-list-day-side-text {
    color: ${props => props.theme.palette.white.main};
  };
  .fc-list-event:hover td{
      cursor: pointer;
      background-color: ${props => props.theme.palette.gray[100]};
    
  };
`;

let calendar;

let today = new Date();
let y = today.getFullYear();
let m = today.getMonth();
let d = today.getDate();

const eventsArray = [
  {
    id: 10,
    title: "Cyber Week",
    start: new Date(y, m, 2),
    allDay: true,
    className: "bg-yellow",
    description:
      "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
  },
];

// quick find: Calendar
const CalendarView = () => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [events, setEvents] = React.useState(eventsArray);
  const [alert, setAlert] = React.useState(null);
  const [modalAdd, setModalAdd] = React.useState(false);
  const [modalChange, setModalChange] = React.useState(false);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [radios, setRadios] = React.useState(null);
  const [eventId, setEventId] = React.useState(null);
  const [eventTitle, setEventTitle] = React.useState("");
  const [eventDescription, setEventDescription] = React.useState("");
  const { currentEtoroUserData } = useEtoroUser();
  const theme = useTheme();
  // eslint-disable-next-line
  const [event, setEvent] = React.useState(null);
  const [currentDate, setCurrentDate] = React.useState(null);
  const calendarRef = React.useRef(null);
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'Calendar' });
  const [width, setWidth] = React.useState(window.innerWidth);
  const isMobile = width <= 768;

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  React.useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);
  
  React.useEffect(() => {
    if(currentEtoroUserData?.allCalendarEvents) {
      createCalendar();
    }
  }, [currentEtoroUserData]);
  React.useEffect(() => {
    if(currentEtoroUserData?.allCalendarEvents) {
      createCalendar();
      calendar.addEvent({
          id: 0,
          start: new Date(),
          end: new Date(),
          title: "Last username refresh",
          description: "",
          display: 'background',
          allDay: true,
          backgroundColor: theme.palette.bsColors.LogoLightBlue,
      });
    }
  }, [isMobile]);
  const createCalendar = () => {
    calendar = new Calendar(calendarRef.current, {
      plugins: [interaction, dayGridPlugin,listPlugin],
      initialView: (isMobile ? "listWeek" : "dayGridMonth"),
      selectable: false,
      editable: false,
      contentHeight:"auto",
      events: currentEtoroUserData.allCalendarEvents,
      headerToolbar: "",
      // Add new event
      select: (info) => {
        setModalAdd(true);
        setStartDate(info.startStr);
        setEndDate(info.endStr);
        setRadios("bg-info");
      },
      eventContent: function(arg) {
        let arrayOfDomNodes = [];
        // image event
        let titleEvent = document.createElement('div');
        if(arg.event._def.title && arg.event.extendedProps.tickerLogo) {
          let imgEvent = '<img src="'+arg.event.extendedProps.tickerLogo+'" style="max-width: 25px !important; border-radius: 3px 10px 10px 3px;"> ' + arg.event._def.title
          titleEvent.classList = "fc-event-img"
          titleEvent.innerHTML = imgEvent;
        }

        arrayOfDomNodes = [ titleEvent ]

        return { domNodes: arrayOfDomNodes }
      },
      eventClick: function(info) {
        if (info.event.extendedProps.description) {
          setAlert(
            <ReactBSAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={info.event.extendedProps.description}
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            btnSize=""
            confirmBtnStyle={{
              marginRight: undefined,
              borderColor: undefined,
              boxShadow: undefined,
            }}
            text=""
          />
          ) 
        }
      }
    });
    calendar.render();
    setCurrentDate(getTranslatedMonth(calendar.view.title));
  };

  React.useEffect(() => {
    setCurrentDate(getTranslatedMonth(calendar.view.title));
  }, [t]);

  function getTranslatedMonth(dateString) {
    const currentDateArray = calendar.view.title.split(" ")
    const currentMonth = currentDateArray[0];
    const currentYear = currentDateArray[1];
    return t(currentMonth) + " " + currentYear
  }

  const changeView = (newView) => {
    if (newView === "next") {
      calendar.next();
    } else if (newView === "prev") { 
      calendar.prev();
    } else {
      calendar.today();
    }
    setCurrentDate(getTranslatedMonth(calendar.view.title));
  };

  const addNewEvent = () => {
    var newEvents = events;
    newEvents.push({
      title: eventTitle,
      start: startDate,
      end: endDate,
      className: radios,
      id: events[events.length - 1] + 1,
    });
    calendar.addEvent({
      title: eventTitle,
      start: startDate,
      end: endDate,
      className: radios,
      id: events[events.length - 1] + 1,
    });
    setModalAdd(false);
    setEvents(newEvents);
    setStartDate(undefined);
    setEndDate(undefined);
    setRadios("bg-info");
    setEventTitle("");
  };
  
  const changeEvent = () => {
    var newEvents = events.map((prop) => {
      if (prop.id + "" === eventId + "") {
        setEvent(undefined);
        calendar.getEventById(eventId).remove();
        let saveNewEvent = {
          ...prop,
          title: eventTitle,
          className: radios,
          description: eventDescription,
        };
        calendar.addEvent(saveNewEvent);
        return {
          ...prop,
          title: eventTitle,
          className: radios,
          description: eventDescription,
        };
      } else {
        return prop;
      }
    });
    setModalChange(false);
    setEvents(newEvents);
    setRadios("bg-info");
    setEventTitle("");
    setEventDescription("");
    setEventId(undefined);
    setEvent(undefined);
  };
  const deleteEventSweetAlert = () => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => {
          setAlert(false);
          setRadios("bg-info");
          setEventTitle("");
          setEventDescription("");
          setEventId(undefined);
        }}
        onCancel={() => deleteEvent()}
        confirmBtnCssClass="btn-secondary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Cancel"
        cancelBtnText="Yes, delete it"
        showCancel
        btnSize=""
      >
        You won't be able to revert this!
      </ReactBSAlert>
    );
  };
  const deleteEvent = () => {
    event.remove();
    var newEvents = events.filter((prop) => prop.id + "" !== eventId);
    setEvent(undefined);
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Success"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        confirmBtnText="Ok"
        btnSize=""
      >
        Event deleted!
      </ReactBSAlert>
    );
    setModalChange(false);
    setEvents(newEvents);
    setRadios("bg-info");
    setEventTitle("");
    setEventDescription("");
    setEventId(undefined);
    setEvent(undefined);
  };

  return (
    <>
      {alert}
      <AlternativeHeader section={t("header")}/>

      {/* Page content */}
      <Helmet>
        <title>Calendar | Bullsheet</title>
      </Helmet>
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <Grid
            container
            component={Box}
            alignItems="center"
            paddingTop="1.5rem"
            paddingBottom="1.5rem"
          >
            <Grid item xs={12} lg={6}>
              <Typography
                variant="h2"
                component="h2"
                style={{marginLeft:"1.5rem"}}
                className={clsx(
                  classes.displayInlineBlock,
                  classes.mb0,
                  classes.textBlack
                )}
              >
                {isMobile ? "Week's Events" : currentDate}
              </Typography>
              <FeatureInfoWithBox description={t("infoCalendarTooltip")}/>
              
            </Grid>
            <Grid item xs={12} lg={6} className={classes.textLgRight}>
             <Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                onClick={() => {
                  changeView("prev");
                }}
              >
                <NavigateBefore />
              </Button>
              <Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                onClick={() => changeView("dayGridMonth")}
              >
                {isMobile ? "Current Week" : t('currentMonth')}
              </Button>
              
              <Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                style={{marginRight:"1.5rem"}}
                onClick={() => {
                  changeView("next");
                }}
              >
                <NavigateNext />
              </Button>
              {/*<Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                onClick={() => changeView("dayGridMonth")}
              >
                Month
              </Button>
               <Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                onClick={() => changeView("dayGridWeek")}
              >
                Week
              </Button>
              <Button
                variant="contained"
                size="small"
                className={classes.buttonRoot}
                onClick={() => changeView("dayGridDay")}
              >
                Day
              </Button> */}
            </Grid>
          </Grid>
              <CardContent className={classes.p0}>
                <FullCalendarWrapper theme={theme}>
                <div
                  className="calendar"
                  data-toggle="calendar"
                  id="calendar"
                  ref={calendarRef}
                />
                </FullCalendarWrapper>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={modalChange}
        keepMounted
        onClose={() => setModalChange(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <FormGroup>
            <FormLabel>Event title</FormLabel>
            <FilledInput
              placeholder="Event Title"
              type="text"
              value={eventTitle}
              onChange={(e) => setEventTitle(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>Status</FormLabel>
            <Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  classes={{
                    root: clsx(
                      classes.buttonContainedInfo,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-info")}
                >
                  {radios === "bg-info" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  classes={{
                    root: clsx(
                      classes.buttonContainedWarning,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-warning")}
                >
                  {radios === "bg-warning" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  classes={{
                    root: clsx(
                      classes.buttonContainedError,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-danger")}
                >
                  {radios === "bg-danger" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  classes={{
                    root: clsx(
                      classes.buttonContainedSuccess,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-success")}
                >
                  {radios === "bg-success" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  color="default"
                  classes={{
                    root: clsx(
                      classes.buttonContainedDefault,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-default")}
                >
                  {radios === "bg-default" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
              <Box display="inline-block" marginRight=".5rem">
                <IconButton
                  color="primary"
                  classes={{
                    root: clsx(
                      classes.buttonContainedPrimary,
                      classes.radioButton
                    ),
                  }}
                  onClick={() => setRadios("bg-primary")}
                >
                  {radios === "bg-primary" && (
                    <Box
                      width="1.25rem!important"
                      height="1.25rem!important"
                      component={Check}
                    />
                  )}
                </IconButton>
              </Box>
            </Box>
          </FormGroup>
          <FormGroup>
            <FormLabel>Description</FormLabel>
            <FilledInput
              placeholder="Event Desctiption"
              type="text"
              multiline
              rows="4"
              value={eventDescription}
              onChange={(e) => setEventDescription(e.target.value)}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Box width="100%" display="flex" justifyContent="space-between">
            <Box>
              <Box display="inline-block" marginRight=".5rem">
                <Button
                  color="primary"
                  variant="contained"
                >
                  Update
                </Button>
              </Box>
              <Button
                classes={{
                  root: classes.buttonContainedError,
                }}
                variant="contained"
                onClick={() => {
                  setModalChange(false);
                  deleteEventSweetAlert();
                }}
              >
                Delete
              </Button>
            </Box>
            <Button onClick={() => setModalChange(false)} color="primary">
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CalendarView;
